import { useCallback } from 'react';

import { useGenericSend } from '../useGenericSend';
import * as Types from './types';

export const useBonusTrigger = () => {
    const send = useGenericSend();

    return useCallback(async (request: Types.IBonusTriggerRequestData): Promise<Types.IBonusTriggerResponseData> => {
        const { data } = await send<Types.IBonusTriggerRequestData, Types.IBonusTriggerResponseData>({
            ID: 31065,
            description: 'Trigger bonus',
            responses: [31066, 31067],
            errorLevel: 1,
            ...request
        });

        return data;
    }, [
        send
    ]);
};
